import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss'],
  standalone: false
})
export class EmailInputComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() inputcss: any;
  @Output() emailInputted = new EventEmitter<string>();

  errorMessage: string;

  constructor() { }

  ngOnInit() {
  }

  onInputEmail(value) {
    this.emailInputted.emit(value);
  }

  get email() { return this.parentForm.get('email'); }

  isEmailRegisteredError() {
    return this.email.errors &&
      this.email.errors.isEmailRegistered &&
      this.email.touched;
  }

  /** True when email format is invalid (Validators.pattern or Validators.email). */
  isEmailFormatInvalidError(): boolean {
    return !!(
      this.email?.errors &&
      (this.email.errors.pattern || this.email.errors.email) &&
      this.email.touched
    );
  }

  isEmailRequiredError() {
    return this.email.errors &&
      this.email.errors.required &&
      this.email.touched;
  }

  /** Returns true only when the email control has a known error and we have a message to show. */
  isEmailInputError(): boolean {
    if (!this.email?.errors || !this.email.touched) {
      return false;
    }
    if (this.isEmailRegisteredError()) {
      this.errorMessage = 'Email already registered.';
      return true;
    }
    if (this.isEmailFormatInvalidError()) {
      this.errorMessage = 'Email format invalid.';
      return true;
    }
    if (this.isEmailRequiredError()) {
      this.errorMessage = 'Email required.';
      return true;
    }
    return false;
  }

}
